var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-icon',{attrs:{"stato":_vm.stato,"color":_vm.color,"large":""}},[_vm._v("lens")])
}
var staticRenderFns = []

export { render, staticRenderFns }